import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FCLink from '../../../fc_link/fc_link';
import Image from '../../../image/image';

export default function VideoCard(props) {
  const { config, metadata, cardEvent, hasLink } = props;
  const videoState = get(metadata, 'isVideoActive')
    ? `card--video-active`
    : `card--video-play`;
  const content = [
    <Image
      key={get(metadata, 'featured_image.source')}
      alt={get(metadata, 'title')}
      src={get(metadata, 'featured_image.source')}
      assetSizes={get(metadata, 'assetSizes')}
    />,
    <figcaption key={get(metadata, 'title')}>
      <h2 className="card__title card__title--video">
        {get(metadata, 'title')}
      </h2>
    </figcaption>
  ];

  return (
    <figure
      className={`card card--video ${videoState}`}
      onClick={event => cardEvent(event, get(metadata, 'index'))}
    >
      {hasLink ? (
        <FCLink
          config={config}
          to={get(metadata, 'link')}
          title={get(metadata, 'title')}
          externalLink={get(metadata, 'external')}
          targetWindow={get(metadata, 'targetWindow')}
        >
          {content}
        </FCLink>
      ) : (
        content
      )}
    </figure>
  );
}

VideoCard.defaultProps = {
  cardEvent: () => {},
  hasLink: true
};

VideoCard.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  cardEvent: PropTypes.func,
  hasLink: PropTypes.bool
};
